import { createSelector } from 'reselect';
import { eventSelector } from './EventSelectors';
import {
    markersSelector,
    settingsSelector,
    fillSessionWithExternalData,
    shouldFetchAgendaSettingsSelector, shouldFetchMarkersSelector, shouldFetchRegistrationEnabledSelector,
    speakerWithFullNameSelector,
    sponsorsSelector,
    sessionsOpenForRegistrationByTicketSelector,
    overlappingSessionsByTicketSelector,
    sessionsRegistrationTicketRulesSelector,
    ticketsRegisteredSessionIdsSelector,
    favSessionIdsSelector,
    registeredSessionIdsSelector,
} from './AgendaSelectors';
import { shouldFetchRegisteredSessionsSelector } from './MeSelectors';

export const sessionSpeakersSelector = createSelector(
    state => state.sessionReducer.speakers,
    speakers => speakers ?
        speakers.reduce(
            (speakers, speaker) => {
                speakers[speaker.id] = {...speaker, fullName: speakerWithFullNameSelector(speaker)};
                return speakers;
            }, {}
        ) :
        {}
);
// TODO refactor / simplify
export const selectedSessionSelector = createSelector(
    markersSelector,
    state => state.meReducer.me,
    ticketsRegisteredSessionIdsSelector,
    sessionsOpenForRegistrationByTicketSelector,
    sessionsRegistrationTicketRulesSelector,
    overlappingSessionsByTicketSelector,
    eventSelector,
    settingsSelector,
    state => state.sessionReducer.session,
    sponsorsSelector,
    state => state.userProfilePageReducer.selectedTicketsIds,
    (markers, me, registeredSessionIds, openSessRegSessionsIds, ticketRules, overlappingSessions, event, settings, session, sponsors, selectedTicketsIds) => {
        if (session === null || settings === null) {
            return null;
        }
        const registeredSessionIdsArr = registeredSessionIds === null ? [] : registeredSessionIds;
        return fillSessionWithExternalData(markers, me, registeredSessionIdsArr, openSessRegSessionsIds, selectedTicketsIds, ticketRules, overlappingSessions, event, settings, session, sponsors);
    }
);

export const upcomingSessionsSelector = createSelector(
    [
        state => state.sessionReducer.upcomingSessions,
        favSessionIdsSelector,
        registeredSessionIdsSelector,
        selectedSessionSelector,
        (state, timeRange) => timeRange
    ],
    (upcomingSessions, favIds, regIds, currentSession, timeRange = 0) => {
        const registeredFor = [];
        const favourite = [];
        const remaining = [];

        if (!currentSession) {
            return [];
        }

        upcomingSessions?.forEach(session => {
            const currentSessionEndInMs = new Date(currentSession.endTime).valueOf();
            const upcomingSessionStartInMs = new Date(session.startTime).valueOf();

            if (upcomingSessionStartInMs > currentSessionEndInMs + timeRange) {
                return;
            }

            if (regIds.includes(session.id)) {
                registeredFor.push(session);
                return;
            } else if (favIds.includes(session.id)) {
                favourite.push(session);
                return;
            }

            remaining.push(session);
        });

        return [...registeredFor, ...favourite, ...remaining];
    }
);

export const currentSessionVirtualDetailsSelector = createSelector(
    [
        state => state.sessionReducer.session,
        state => state.sessionReducer.virtualDetails,
    ],
    (session, virtualDetails) => (session && virtualDetails?.sessionId) &&
        (session.id === virtualDetails.sessionId) ?
        virtualDetails :
        null
);
